import src from "IMAGE";
export default { src, width: 478, height: 70, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAHElEQVR42mOQlZPxBeIYIA4HYn8g9oGyY4E4CgBVjgViI/WzCQAAAABJRU5ErkJggg==", blurWidth: 8, blurHeight: 1 }
